/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TicketSubsidyLogDto } from '../../models/ticket-subsidy-log-dto';

export interface TicketSubsidyControllerFindLogsByTicketId$Params {
  ticketId: string;
}

export function ticketSubsidyControllerFindLogsByTicketId(http: HttpClient, rootUrl: string, params: TicketSubsidyControllerFindLogsByTicketId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TicketSubsidyLogDto>>> {
  const rb = new RequestBuilder(rootUrl, ticketSubsidyControllerFindLogsByTicketId.PATH, 'get');
  if (params) {
    rb.query('ticketId', params.ticketId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TicketSubsidyLogDto>>;
    })
  );
}

ticketSubsidyControllerFindLogsByTicketId.PATH = '/api/ticket-subsidy';
